export const blockIconsPhotoandimageNatureNew = (
	<span className='material-symbols-outlined'>nature</span>
);
